import React from 'react';
import { CHAT_DOTS } from '@livingsecurity/shared';

const LoadingDots = ({ coverElement, ...rest }) => (
  <img src={CHAT_DOTS} alt="loader" style={{ height: '16px', marginTop: '5px' }} />
);

export default LoadingDots;
